<template>
    <Card :bordered="false" class="border-radius-0">
        <Form :colon="false" :ref="e => (refs.form = e)" layout="horizontal">
            <TemplateBuilder :rowProp="data.rowProp" :useForm="data.useForm" :fields="data.fields" :skeleton="isLoading"></TemplateBuilder>
        </Form>
    </Card>
</template>

<script>
import { Card, Form } from "ant-design-vue";
import { computed, defineAsyncComponent, defineComponent, reactive } from "vue";
import { state as stateApp } from "../../../app.logic";
import { createFormTitle, initForm, isLoading } from "./profile.logic";

export default defineComponent({
    components: {
        Card,
        Form,
        TemplateBuilder: defineAsyncComponent(() => import("../../../components/input/template-builder/TemplateBuilder"))
    },
    props: {
        menuContext: { default: () => stateApp.menuContext }
    },
    setup(props) {
        const data = reactive({ rowProp: { gutter: 24 } });
        const refs = reactive({ form: null, changePassword: null });
        initForm({ props, data, refs });
        const title = computed(() => createFormTitle({ data }));
        return {
            props,
            data,
            refs,
            title,
            isLoading
        };
    }
});
</script>
